import RequestConvertQuoteCustomState from "@crescentParts/Store/Data/RequestConvertQuote/RequestConvertQuoteState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

const initialState = {
    isEmalSending: false
};

const reducer = {
    "Custom/RequestConvertQuote/BeginEmailSend":(draft:Draft<RequestConvertQuoteCustomState>)=>{
        draft.isEmalSending = true
    },
    "Custom/RequestConvertQuote/CompleteEmailSend":(draft:Draft<RequestConvertQuoteCustomState>)=>{
        draft.isEmalSending = false
    },
}

export default createTypedReducerWithImmer(initialState, reducer);